import React, { useState, useEffect } from "react";
import { viewAllAdmins } from "../Apis/SuperadminApis";
import "./ChatSidebar.css";
import { FaUserGroup } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import PopupMessage from "../PopupMessage/PopupMessage";

const ChatSidebar = ({ onSelectChat, selectedChatId, userRole, unreadData }) => {
  const navigate = useNavigate();
  console.log("USER ROLE:", userRole);

  const [chats, setChats] = useState([
    { id: 1, name: "General Group", type: "group", unread: 0 }
  ]);

  const [admins, setAdmins] = useState([]);
  const [superAdmins, setSuperAdmins] = useState([]);
const [popupOpen, setPopupOpen] = useState(false);
const [popupMessage, setPopupMessage] = useState("");
const [popupType, setPopupType] = useState("info");

  useEffect(() => {
    if (unreadData) {
      setChats(prev =>
        prev.map(chat =>
          chat.id === 1
            ? { ...chat, unread: unreadData.groupUnread || 0 }
            : chat
        )
      );
    }
  }, [unreadData?.groupUnread]);

  useEffect(() => {
    if (!userRole) return;

    if (userRole === "superadmin") {
      fetchAdmins();
    } else if (userRole === "admin") {
      fetchSuperAdmin();
    }
  }, [userRole]);

  const fetchAdmins = async () => {
    try {
      const response = await viewAllAdmins({});
      if ( response?.error &&
      response.error.toLowerCase().includes("unauthorized")) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
      if (!response.error) {
        setAdmins(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch admins:", error);
      if (
    error?.response?.status === 401 ||
    error?.message?.includes("Unauthorized")
  ) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    return;
    }
  }
  };

  const fetchSuperAdmin = async () => {
    try {
      const res = await viewAllAdmins({ action: "superadmin" });
      if ( res?.error &&
      res.error.toLowerCase().includes("unauthorized")) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
      if (!res.error && res.data) {
        setSuperAdmins(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch superadmin:", err);
      if (
    err?.response?.status === 401 ||
    err?.message?.includes("Unauthorized")
  ) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    return;
  }
    }
  };

  const getUserUnreadCount = (userId, type) => {
    if (!unreadData?.unreadBySender) return 0;
    
    const found = unreadData.unreadBySender.find(item => {
      if (type === "admin") {
        return item.admin_id === userId;
      } else {
        return item.superadmin_id === userId;
      }
    });
    
    return found?.count || 0;
  };

  const formatNameFromEmail = (email) => {
    if (!email) return "";
    const namePart = email.split("@")[0];
    return namePart
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/[^a-zA-Z]/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getAvatarColor = (value) => {
    const colors = [
      "#4a90e2", "#50bfa0", "#f5a623",
      "#e94e77", "#9b59b6", "#ff6b6b",
      "#0080ff", "#6c5ce7", "#00b894"
    ];

    let hash = 0;
    for (let i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const getDisplayValue = (item, type) => {
    return type === "superadmin"
      ? item.email
      : item.name || item.email;
  };

  return (
    
    <div className="cs-chat-sidebar">
       <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
      <div className="cs-sidebar-header">
        <h2 className="cs-header-title">Messages</h2>
        {unreadData?.totalUnread > 0 && (
          <span className="cs-unread-badge">{unreadData.totalUnread}</span>
        )}
      </div>

      <div className="cs-chats-list">
        {chats.map(chat => (
          <div
            key={chat.id}
            className={`cs-chat-item ${selectedChatId === chat.id ? "cs-active" : ""}`}
            onClick={() => onSelectChat(chat)}
          >
            <div className="cs-chat-avatar">
              <span className="cs-avatar-icon"><FaUserGroup /></span>
            </div>
            <div className="cs-chat-info">
              <div className="cs-chat-name">{chat.name}</div>
            </div>
            {chat.unread > 0 && (
              <div className="cs-chat-unread">{chat.unread}</div>
            )}
          </div>
        ))}
      </div>

      {userRole === "superadmin" && (
        <div className="cs-admins-section">
          <div className="cs-section-title">
            Admins ({admins.length})
          </div>

          {admins.length === 0 ? (
            <div className="cs-no-admins">No admins found</div>
          ) : (
            admins.map(admin => {
              const unreadCount = getUserUnreadCount(admin.id, "admin");
              
              return (
                <div
                  key={admin.id}
                  className={`cs-admin-item ${selectedChatId === admin.id ? "cs-active" : ""}`}
                  onClick={() =>
                    onSelectChat({
                      id: admin.id,
                      name: admin.name || formatNameFromEmail(admin.email),
                      type: "admin",
                      receiver_admin_id: admin.id,
                      is_login: admin.is_login,
                      logout_on: admin.logout_on
                    })
                  }
                >
                  <div className="cs-avatar-wrapper">
                    <div
                      className="cs-admin-avatar"
                      style={{
                        background: getAvatarColor(getDisplayValue(admin, "admin") || "")
                      }}
                    >
                      {(getDisplayValue(admin, "admin") || "").charAt(0).toUpperCase()}
                    </div>
                    {admin.is_login && <span className="cs-online-dot"></span>}
                  </div>

                  <div className="cs-admin-name">
                    {admin.name || formatNameFromEmail(admin.email) || admin.contact_name}
                  </div>

                  {unreadCount > 0 && (
                    <div className="cs-chat-unread">{unreadCount}</div>
                  )}
                </div>
              );
            })
          )}
        </div>
      )}

      {userRole === "admin" && superAdmins.length > 0 && (
        <div className="cs-admins-section">
          <div className="cs-section-title">
            Super Admins ({superAdmins.length})
          </div>

          {superAdmins.map(sa => {
            const unreadCount = getUserUnreadCount(sa.id, "superadmin");
            
            return (
              <div
                key={sa.id}
                className={`cs-admin-item ${selectedChatId === sa.id ? "cs-active" : ""}`}
                onClick={() =>
                  onSelectChat({
                    id: sa.id,
                    name: sa.name,
                    email: formatNameFromEmail(sa.email),
                    type: "superadmin",
                    receiver_superadmin_id: sa.id,
                    is_login: sa.is_login,
                    logout_on: sa.logout_on
                  })
                }
              >
                <div className="cs-avatar-wrapper">
                  <div
                    className="cs-admin-avatar"
                    style={{
                      background: getAvatarColor(getDisplayValue(sa, "superadmin") || "")
                    }}
                  >
                    {(getDisplayValue(sa, "superadmin") || "").charAt(0).toUpperCase()}
                  </div>
                  {sa.is_login && <span className="cs-online-dot"></span>}
                </div>

                <div className="cs-admin-name">
                  {sa.name || formatNameFromEmail(sa.email)}
                </div>

                {unreadCount > 0 && (
                  <div className="cs-chat-unread">{unreadCount}</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ChatSidebar;